import { useMemo } from "react";
import { AuditoinnitCacheKeys } from "../cacheKeys";
import { getContextService } from '../../services/contextService';
import * as Endpoint from "../../../endpoints";
import { getSgApiService } from "../../../sg-core/services/ApiService2";
import { useAuthContext } from "../../auth/AuthenticationProvider";
import { useSWROffline } from "../../../sg-core/swr/useSWROffline";

export type IUseUserAppRolesHook = () => {
    data: string[];
    fetching: boolean;
    error: any
}

export const useUserAppRoles: IUseUserAppRolesHook = () => {
    const { token, lang, anonymousSession } = useAuthContext();

    const fetcher = async (): Promise<string[]> => {
        if (!token) return [];
        const service = getContextService(getSgApiService(token), Endpoint.auditoinnit, anonymousSession);

        const initialData = await service.getUserAppRoles()

        if (initialData.isFailure) {
            throw initialData.error;
        }

        return initialData.value;
    };

    const cacheKey = AuditoinnitCacheKeys(token, lang).AppRoles;
    const { data, isValidating, error } = useSWROffline(
        cacheKey,
        fetcher,

        { suspense: true, revalidateOnFocus: false, revalidateOnMount: false }
    );

    const rawData = data ?? [];

    return useMemo(() => ({
        data: rawData,
        fetching: isValidating,
        error
    }), [rawData, isValidating]);
};
